import { OrderItem, Promotion } from 'kiolyn-api';
import { cloneDeep, isEmpty } from 'lodash';
import checkIsPromotionItem from './CheckIsPromotionItem';
import newId from './NewId';

export default function applyCheapestPromotion(
  promotion: Promotion,
  items: OrderItem[]
): void {
  if (
    isEmpty(items) ||
    promotion.promotion_type !== 'buy_st_get_cheapest_one_free' ||
    promotion.buy_items === undefined ||
    promotion.get_quantity === undefined ||
    promotion.get_quantity <= 0
  ) {
    return;
  }

  let getQuantity = promotion.get_quantity;
  const sortedItems = [...items]
    .reverse()
    .sort((a, b) => (a.price ?? 0) - (b.price ?? 0));

  for (const item of sortedItems) {
    if (item.IsPromotion) {
      continue;
    }

    const index = promotion.buy_items.findIndex(it =>
      checkIsPromotionItem(item, it)
    );
    if (index >= 0) {
      const itemQuantity = item.count ?? 0;
      if (itemQuantity <= getQuantity) {
        getQuantity -= itemQuantity;
        item.IsPromotion = true;
        item.promotion_id = promotion.id;
        item.promotion_name = promotion.name;
      } else {
        const cloneItem = cloneDeep(item);
        cloneItem.id = newId();
        item.count = (item.count ?? 0) - getQuantity;
        cloneItem.count = getQuantity;
        cloneItem.IsPromotion = true;
        cloneItem.promotion_id = promotion.id;
        cloneItem.promotion_name = promotion.name;
        items.push(cloneItem);
        getQuantity = 0;
      }

      if (getQuantity === 0) {
        promotion.applied_count = (promotion.applied_count ?? 0) + 1;
        break;
      }
    }
  }
}
